import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cc-mobile-header',
  templateUrl: './mobile-header.component.html',
  styleUrls: ['./mobile-header.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class MobileHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
